import React, { useState } from "react";

export default function ImportLootspotModal({ onImport, onClose }) {
  const [text, setText] = useState("");
  const [error, setError] = useState("");

  const handleImport = () => {
    try {
      const data = JSON.parse(text);
      if (!Array.isArray(data)) throw new Error("JSON must be an array of markers!");
      onImport(data);
      onClose();
    } catch (e) {
      setError("Greška: " + e.message);
    }
  };

  return (
    <div className="animate-fadein fixed inset-0 z-50 flex items-center justify-center bg-[#181c24cc] backdrop-blur-md">
      <div
        style={{
          background: "linear-gradient(135deg, #23244d 80%, #2d225a 100%)",
          border: "2.5px solid #a084ee", // tamnija ljubičasta
          borderRadius: 18,
          boxShadow: "0 4px 32px #a084ee55, 0 0 16px #a084ee", // tamnija ljubičasta glow
          fontFamily: "Montserrat, Inter, Arial, sans-serif",
          color: "#fff",
          padding: "2.5rem 2rem 2rem 2rem",
          minWidth: 340,
          maxWidth: 420,
          width: "100%",
          position: "relative",
          textAlign: "center",
        }}
      >
        <button
          type="button"
          style={{
            position: "absolute",
            top: 14,
            right: 18,
            fontSize: 28,
            color: "#a084ee",
            background: "none",
            border: "none",
            fontWeight: 900,
            cursor: "pointer",
            textShadow: "0 0 8px #a084ee",
          }}
          onClick={onClose}
        >
          &times;
        </button>
        <h2
          style={{
            fontSize: "1.35rem",
            fontWeight: 800,
            marginBottom: 18,
            background: "linear-gradient(90deg,#e0aaff 0%,#a084ee 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            letterSpacing: 1.2,
            textShadow: "0 2px 12px #a084ee",
          }}
        >
          Import Lootspot JSON
        </h2>
        <textarea
          className="mb-3 w-full rounded border p-2"
          style={{
            background: "#181c24",
            color: "#fff",
            border: "1.5px solid #a084ee",
            borderRadius: 10,
            fontFamily: "Montserrat,Inter,Arial,sans-serif",
            fontWeight: 500,
            boxShadow: "0 2px 8px #a084ee33",
          }}
          rows={8}
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="Paste JSON here..."
        />
        {error && (
          <div
            style={{
              background: "#a084ee22",
              color: "#a084ee",
              padding: "6px 0",
              borderRadius: 8,
              marginBottom: 10,
              fontWeight: 600,
              boxShadow: "0 2px 8px #a084ee",
            }}
          >
            {error.replace("Greška: ", "")}
          </div>
        )}
        <button
          style={{
            background: "linear-gradient(90deg,#e0aaff 0%,#a084ee 100%)",
            color: "#23244d",
            fontWeight: 700,
            padding: "10px 0",
            borderRadius: 10,
            marginTop: 8,
            boxShadow: "0 2px 12px #a084ee55",
            width: "100%",
            fontSize: 17,
            letterSpacing: 0.5,
            transition: "filter 0.18s",
          }}
          onClick={handleImport}
          onMouseEnter={(e) => (e.currentTarget.style.filter = "brightness(1.08)")}
          onMouseLeave={(e) => (e.currentTarget.style.filter = "brightness(1.0)")}
        >
          Import
        </button>
      </div>
    </div>
  );
}
